<div class="budget-redirect-block">
    <a mat-flat-button
       color="primary"
       class="budget-redirect-button"
       [disableRipple]="true"
       [routerLink]="urlPath"
       [queryParams]="urlQueryParams"
       (click)="onNavigate()">
        {{ label }}
        <i class="ph-bold ph-arrow-right icon-text icon-16" aria-hidden="true"></i>
    </a>
    <span *ngIf="helperText" class="budget-redirect-helper">
        {{ helperText }}
    </span>
</div>
